import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// import devWarning from '../_util/devWarning';
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// const Icon = () => {
//   devWarning(false, 'Icon', 'Empty Icon');
//   return null;
// };
// export default Icon;
import React from 'react';
import classnames from 'classnames';
var Icon = function Icon(props) {
  // useEffect(() => {
  //   let secScript = document.createElement("script");
  //   secScript.setAttribute("src", "https://at.alicdn.com/t/font_3159075_s68oy5ladc.js");
  //   document.body.insertBefore(secScript, document.body.lastChild);
  // }, [])
  // return (
  //   <svg className="icon" aria-hidden="true">
  //     <use xlinkHref={`#${props.type}`} />
  //   </svg>
  // )
  var type = props.type,
    style = props.style,
    other = __rest(props, ["type", "style"]);
  var cls = classnames(_defineProperty({
    'icon': true
  }, "icon-".concat(type), true));
  return /*#__PURE__*/React.createElement("i", _extends({
    className: cls
  }, other, {
    style: style
  }));
};
export default Icon;